import { DetailsChildrenTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';
import ChronologyListItem from 'app/main/modules/chronology/ChronologyListItem';
import OpportunitiesListItem from 'app/main/modules/opportunities/OpportunitiesListItem';
import WorkReportsListItem from 'app/main/modules/workreports/WorkReportsListItem';

import ActivitiesDetailsTab from './tabs/ActivitiesDetailsTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <ActivitiesDetailsTab {...props} />
	},
	{
		id: 'opportunities',
		title: 'MODULE_OPPORTUNITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('opportunities') || authorizer.cannot('view', 'opportunities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="opportunities"
				content={{ type: 'list', itemLayout: OpportunitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'oppo_acti_uid', filt_clause: 'equals', filt_value: model.acti_uid }]}
			/>
		)
	},
	{
		id: 'chronology',
		title: 'MODULE_CHRONOLOGY_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('chronology') || authorizer.cannot('view', 'chronology'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="chronology"
				content={{ type: 'list', itemLayout: ChronologyListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'chro_acti_uid', filt_clause: 'equals', filt_value: model.acti_uid }]}
			/>
		)
	},
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ authorizer }) => authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'acti_parent_acti_uid', filt_clause: 'equals', filt_value: model.acti_uid }
				]}
			/>
		)
	},
	{
		id: 'workreports',
		title: 'MODULE_WORKREPORTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('workreports') || authorizer.cannot('view', 'workreports'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="workreports"
				content={{ type: 'list', itemLayout: WorkReportsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'wore_acti_uid', filt_clause: 'equals', filt_value: model.acti_uid }]}
			/>
		)
	}
];

export default tabs;
